// Popula a seção
function populateDepoimentos($parent, section, action = 'insert') {
  if ($parent.length > 0 && section) {
    // Atualiza a seção (Remove antes para ser criada novamente)
    if (action === 'update') {
      const $sectionUpd = $('#' + section.id);
      if ($sectionUpd.length > 0) {
        $sectionUpd.html('');
        $sectionUpd.remove();
      }
    }

    // Exibe seção
    const showSection = section['show'];
    const showSectionClass = !showSection ? 'd-none' : '';

    const fotosShow = section['fotos-show'] == '1';
    const fotosShowClass = !fotosShow ? 'no-img' : '';

    section['quote-show'] === undefined ? 1 : section['quote-show'];
    const quoteShow = section['quote-show'] == '1';
    const quoteShowClass = !quoteShow ? 'no-quote' : '';

    // Layout
    const secLayout = section['layout'] || 'default';

    // Itens
    let itensHTML = `<div class="carousel carousel-depoimentos no-arrows ${secLayout}">`;
    let $itens = $(itensHTML);
    if (section['lista'] && section['lista'].length > 0) {
      section['lista'].forEach((item) => {
        // Foto
        let foto = '';
        if (fotosShow) {
          foto = `<figure class="img img-circle depoimento-foto">
            <img src="${getThumb(item['img'], 100, 100, 'crop')}" width="100px" height="100px" alt="${item['alt']}">
          </figure>`;
        }
        // Estrelas
        let stars = '';
        if (item['stars'] > 1) {
          stars = '<div class="star-rating depoimento-stars">';
          for (let y = 1; y <= 5; y++) {
            const activeStar = parseInt(item['stars']) >= y ? 'active' : '';
            stars += `<label class="${activeStar}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/></svg></label>`;
          }
          stars += '</div>';
        }
        // HTML do item
        let itemHTML = `
        <div class="carousel-item depoimento-wrapper" data-aos="fade-up">
          <div class="depoimento ${fotosShowClass} ${quoteShowClass}">
            <span class="quote-left">${getSvgIcon('quote-left')}</span>
            ${foto}
            <div class="depoimento-infos">
              ${stars}
              <div class="depoimento-nome">${item['titulo']}</div>
              <div class="depoimento-texto">${item['texto']}</div>
            </div>
          </div>
        </div>`;
        const $item = $(itemHTML);
        $itens.append($item);
      });
    }

    // Estrutura da seção
    let sectionHTML = `
    <section id="${section['id']}" data-sec-type="depoimentos" class="home-section depoimentos bg-image ${showSectionClass}">
      <div class="section-content">
        <div class="container">
          <div class="row" data-aos="fade-up" data-aos-offset="0">
            <div class="grid-12">
              <h2 class="title home-title md-text">${section['titulo']}</h2>
            </div>
          </div>
          ${$itens[0].outerHTML}
        </div>
      </div>
    </section>`;

    // Cria o elemento
    let $section = $(sectionHTML);

    // Estilos
    if (Object.keys(section.styles).length > 0) {
      Object.keys(section.styles).forEach((styleVar) => {
        $section[0].style.setProperty('--' + styleVar, section.styles[styleVar]);
      });
    }

    // Ordem da seção
    $section[0].style.setProperty('--order', section['order']);
    $section[0].style.setProperty('order', section['order']);

    // Plano de fundo (Imagem)
    if (section['bg-type'] == 'image') {
      $section[0].style.setProperty('background-image', `url('${section['bg-image']}')`);
    }
    // Plano de fundo (Gradiente)
    else if (section['bg-type'] == 'gradient') {
      $section[0].style.setProperty('background-image', section['bg-gradient']);
    }

    $parent.append($section);

    // Plugins
    setTimeout(() => {
      depoDestroySlick();
      depoInitSlick();
    }, 100);
  }
}
